export default __webpack_public_path__ + "static/media/Mobile.a59c88b7.svg";